import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import heroImg1 from "../../assets/heroImg1.png";
import NFTmeta from "../../assets/NFTmeta.png";
import icon1 from "../../assets/icon1.png";
import icon2 from "../../assets/icon2.png";
import icon3 from "../../assets/icon3.png";
import Navbar from "./Navbar";
import moment from "moment";

let card = [
  {
    src: icon1,
    amountcurrency: "+128K",
    heading: "Current Holders",
  },
  {
    src: icon2,
    amountcurrency: "+2 mILLION",
    heading: "cryptoItem",
  },
  {
    src: icon3,
    amountcurrency: "+3.000 USD",
    heading: "Total Volume",
  },
];

const NavbarLink = styled(Typography)({
  fontFamily: "Zen Dots",
  fontWeight: "400",
  color: "rgba(255, 255, 255, 1)",
});
const HeroDiscover = () => {
  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    const eventDate = moment("2023-5-1 00:00:00"); // set your event date here
    const today = moment();
    const duration = moment.duration(eventDate.diff(today));

    setRemainingTime({
      days: Math.floor(duration.asDays()),
      hours: duration.hours(),
      minutes: duration.minutes(),
      seconds: duration.seconds(),
    });

    const interval = setInterval(() => {
      const today = moment();
      const duration = moment.duration(eventDate.diff(today));

      setRemainingTime({
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const timerData = [
    {
      timeRemaining: remainingTime?.days,
      name: "days",
    },
    {
      timeRemaining: remainingTime?.hours,
      name: "hour",
    },
    {
      timeRemaining: remainingTime?.minutes,
      name: "min",
    },
    {
      timeRemaining: remainingTime?.seconds,
      name: "sec",
    },
  ];

  return (
    <Box
      sx={{
        backgroundImage: `url(${heroImg1})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        pb: 10,
      }}
    >
      <Container>
        <Box pb={3}>
          <Navbar />
        </Box>
        <Grid container>
          <Grid item md={7} xs={12}>
            <Box>
              <NavbarLink
                sx={{ fontSize: { xs: "35px", md: "50px", lg: "65px" } }}
              >
                Discover and
              </NavbarLink>
              <Typography
                sx={{
                  fontSize: { xs: "35px", md: "50px", lg: "65px" },
                  fontFamily: "Zen Dots",
                  fontWeight: "400",
                  WebkitTextStroke: "1px white",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Collect NFTs
              </Typography>

              <NavbarLink
                sx={{ fontSize: { xs: "35px", md: "50px", lg: "65px" } }}
              >
                at scale
              </NavbarLink>
              <Button
                sx={{
                  my: 5,
                  px: 3,
                  py: 1,
                  color: "#FFFFFF",
                  borderRadius: 1,
                  background:
                    "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                }}
              >
                BUY TOKEN
              </Button>
            </Box>
          </Grid>
          <Grid item md={5} xs={0}>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <img src={NFTmeta} width="100%" alt="NFTmeta" />
            </Box>
          </Grid>
        </Grid>
        <Grid container mt={{ md: -5 }}>
          <Grid item sm={7} xs={12}>
            <Box
              sx={{
                display: "flex",
                gap: { xs: 1, md: 3 },
                justifyContent: { xs: "center", md: "left" },
              }}
            >
              {card.map(({ src, amountcurrency, heading }, index) => (
                <Box>
                  <img src={src} alt="CurrentHolders" />
                  <Box
                    sx={{
                      borderRight: index === 2 ? "none" : "1px solid white",
                      pr: 3,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", md: "19.66px" },
                        fontFamily: "Zen Dots",
                        fontWeight: "400",
                        color: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      {amountcurrency}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "10px", md: "18.2px" },
                        fontFamily: "Inter",
                        fontWeight: "600",
                        color: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      {heading}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item sm={5} xs={12} mt={{ xs: 5, sm: 0 }}>
            <Box
              sx={{
                textAlign: "center",
                ml: { xs: 0, md: 10 },
                mt: { xs: 0, sm: -5 },
                borderRadius: "20px",
                py: 2,
                filter: " blur(1)",
                // background:"rgba(91, 248, 255, 1)"
                background:
                  "linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 1)), linear-gradient(90deg, rgba(66, 37, 217, 1) 0%, rgba(87, 212, 230, 1) 100%)",
              }}
            >
              <NavbarLink sx={{ fontSize: "16px", pb: 1 }}>
                Token sale End In!
              </NavbarLink>
              <Stack justifyContent="space-around" direction="row">
                {timerData.map(({ timeRemaining, name }, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: "54px",
                      height: "110px",
                      offset: "28px, 18px rgba(0, 0, 0, 0.51)",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "70%",
                        border: "1px solid rgba(91, 248, 255, 1)",
                        borderRadius: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "24px",
                          fontFamily: "Russo One",
                          fontWeight: "400",
                          color: "rgba(255, 255, 255, 1)",
                        }}
                      >
                        {timeRemaining}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontFamily: "Inter",
                        fontWeight: "700",
                        color: "rgba(255, 255, 255, 1)",
                        textAlign: "center",
                        pt: 1,
                      }}
                    >
                      {name}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
export default HeroDiscover;
